module.exports = __webpack_public_path__ + "img/20.139efe94.jpg";